import React from "react";

const LoadingSpinner = () => (
  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-coralRed" />
);

export default LoadingSpinner;
